import axios, { AxiosInstance, InternalAxiosRequestConfig, AxiosResponse } from 'axios';

const resolveApiBaseUrl = (): string => {
  return process.env.RISK_SCORING_SERVICE_URL || 'https://risk-service-6726edb7ea8f.herokuapp.com';
};

const API_BASE_URL = resolveApiBaseUrl();

const riskScoreClient: AxiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
  },
});

// Simple request/response logging without auth
riskScoreClient.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const fullUrl = `${config.baseURL || ''}${config.url || ''}`;
    console.log('[riskScoreService] Request:', (config.method || 'get').toUpperCase(), fullUrl);
    return config;
  }
);

riskScoreClient.interceptors.response.use(
  (response: AxiosResponse) => {
    console.log('[riskScoreService] Response:', response.status, response.statusText);
    return response;
  },
  (error: any) => {
    console.error('[riskScoreService] Error:', error.response?.status, error.response?.statusText);
    return Promise.reject(error);
  }
);

export const riskScoreService = {
  getRiskScore: async (petId: number): Promise<{
    success: boolean;
    petId: number;
    riskScore: number;
    riskLevel: string;
    decision: string;
    assessmentDate: string;
    fullResults: any;
  }> => {
    try {
      console.log(`🎯 Calculating risk score for pet: ${petId}`);

      const response = await riskScoreClient.post('/calculate-risk-score', {
        pet_id: petId,
      });

      console.log('✅ Risk score calculation completed:', response.data);

      return {
        success: true,
        petId: petId,
        riskScore: response.data.weighted_score || response.data.overall_score,
        riskLevel: response.data.risk_level,
        decision: response.data.decision,
        assessmentDate: response.data.risk_assessment_date,
        fullResults: response.data
      };
      
    } catch (error: any) {
      console.error('❌ Error calculating risk score:', error);
      
      if (error.response?.status === 404) {
        throw new Error(`Pet ${petId} not found in system`);
      } else if (error.response?.status === 500) {
        throw new Error('Risk scoring service temporarily unavailable');
      } else {
        throw new Error(`Risk scoring failed: ${error.message}`);
      }
    }
  },
};